import getCookie from './get-cookie';

export const isFlightExpertSiteRunning = request => {
  const BASE_URL = 'flightsexpert.goibibo.com';
  if (request) {
    return (
      request?.headers?.['x-hostname']?.endsWith?.(BASE_URL) ||
      request?.headers?.host?.endsWith?.(BASE_URL)
    );
  }
  if (typeof window !== 'undefined') {
    return window.location.hostname.endsWith(BASE_URL);
  }
};

export const getMCID = () => {
  return getCookie('gi_mcid');
};
